/*
 * @Author: Tina Huang
 * @Date: 2024-02-27 17:05:46
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-04-11 14:37:35
 * @Description:
 */

import { Badge, Button, Card, Tag, Image } from 'antd'
import { NOTIFY_ITEM, notifies } from '@/constants/notifies'
import { useNavigate } from 'react-router-dom'

export default function NotifyCard() {
  const navigate = useNavigate()

  const handleClick = (item: NOTIFY_ITEM) => {
    item?.pathType === 'navigate' ? navigate(item?.btnPath) : window.open(item.btnPath)
  }

  return (
    <Card className="w-full" style={{ width: 300, marginTop: 16 }} title={<h2 className="text-center">❗️ 重要通知 ❗️</h2>}>
      {notifies
        .filter((item) => !item.hide)
        .map((item) => (
          <div className="text-center">
            <Badge
              status={item?.status || 'success'}
              text={
                <span>
                  {item.title}
                  {item.cover && <Image src={item.cover} className="rounded-md mt-2" />}
                  <div className="flex items-center justify-between mt-2">
                    {item.preview && (
                      <Tag color="pink">
                        <a href={item?.preview} target="_blank" rel="noreferrer">
                          {item?.previewLabel}
                        </a>
                      </Tag>
                    )}
                    <p className="font-bold bg-red-100 rounded-md px-1 text-center">
                      <small>{item?.description}</small>
                    </p>
                  </div>
                </span>
              }
            />
            <br></br>
            {item.btn && (
              <Button type="primary" shape="round" block danger className="mt-4" onClick={() => handleClick(item)}>
                {item.btnText}
              </Button>
            )}
          </div>
        ))}
    </Card>
  )
}
